module.exports = __webpack_public_path__ + "static/allday-fbb924a5bec7d63e5cc57576e872f83e.mp4";